<div class="shell">
  <a class="skip-link" href="#main" (click)="skipToMain($event)">Skip to main content</a>

  <header class="mobile-header d-flex d-md-none justify-content-between align-items-center px-3 w-100">
    <button
      #menuButton
      type="button"
      class="mobile-icon-btn hamburger-btn"
      (click)="openMobileMenu()"
      id="btn-mobileHamburger"
      aria-label="Open menu"
      aria-controls="mobile-drawer"
      [attr.aria-expanded]="showMobileMenu"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M3 12H21" stroke="#333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M3 6H21" stroke="#333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M3 18H21" stroke="#333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
    <div class="mobile-header-title">{{ activeItem?.label ?? 'Lister' }}</div>
    <div class="mobile-header-spacer"></div>
  </header>

  <header class="pos-header d-flex justify-content-between align-content-center gx-0">
    <div class="navbar justify-content-between">
      <div class="d-flex align-items-center header-start">
        <a routerLink="/" class="logo-link" aria-label="Lister home">
          <img alt="" class="logo-img" src="assets/brand/brijjworks-logo.svg" />
        </a>
        <app-breadcrumb></app-breadcrumb>
      </div>

      <div class="d-flex align-items-center justify-content-end">
        @if (status === 'ready') {
          <button
            type="button"
            class="warehouse-switch me-2"
            (click)="switchModule()"
            id="btn-headerWarehouse"
            [attr.aria-label]="'Switch warehouse, current: ' + warehouseLabel"
            [title]="warehouseLabel"
          >
            <span class="image-wrapper">
              <img src="assets/icons/nav/warehouse-dark.svg" alt="" class="warehouse-icon" />
            </span>
            <span class="warehouse-name">
              <span class="warehouse-title">{{ selectedWarehouseName || 'Choose a warehouse' }}</span>
              @if (selectedWarehouseName && selectedLocationName) {
                <span class="warehouse-location">{{ selectedLocationName }}</span>
              }
            </span>
            <img src="assets/icons/nav/down-arrow.svg" alt="" />
          </button>
        }

        <div class="bell-wrapper dropdown">
          <button
            type="button"
            id="btn-appSwitcher"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            aria-label="Switch app"
          >
            <img alt="" width="20" height="20" src="assets/icons/nav/app-switcher.svg" />
          </button>
          <div class="dropdown-menu app-switcher-menu" aria-labelledby="btn-appSwitcher">
            <ng-container [ngTemplateOutlet]="appSwitcher"></ng-container>
          </div>
        </div>

        <div class="dropdown">
          <button
            type="button"
            class="user-profile"
            id="dropdownMenuButton2"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            (show.bs.dropdown)="setDropdownOpen(true)"
            (hide.bs.dropdown)="setDropdownOpen(false)"
          >
            <span class="d-flex align-items-center pe-3">
              @if (!userDetails?.profileImgUrl) {
                <span class="profile-pic" id="demoImg">
                  <img alt="" [src]="user.profileFileUrl ? user.profileFileUrl : 'assets/images/default-profile.png'" />
                </span>
              }
              @if (userDetails?.profileImgUrl) {
                <span class="profile-pic border">
                  <img alt="" class="w-100" [src]="userDetails?.profileImgUrl" />
                </span>
              }
              <!-- The name below is hidden on smaller screens, so the button keeps a name there. -->
              <span class="visually-hidden d-lg-none">Account menu</span>
              <span class="user-name d-none d-lg-block">
                <span class="name">{{ userDetails?.displayName || userDetails?.fullName }}</span>
                <span class="secondary mb-0">{{ userDetails?.roles?.[0] }}</span>
              </span>
            </span>
            <img [class.rotate-icon]="isDropdownOpen" src="assets/icons/nav/down-arrow.svg" alt="" />
          </button>
          <ul class="dropdown-menu mt-1" aria-labelledby="dropdownMenuButton2">
            @if (status === 'ready') {
              <li>
                <button type="button" class="dropdown-item" (click)="switchModule()">
                  <img alt="" class="me-2" src="assets/icons/nav/warehouse.svg" />
                  Switch warehouse
                </button>
              </li>
            }
            <li>
              <button type="button" class="dropdown-item" (click)="signOut()">
                <img alt="" class="me-2" src="assets/icons/nav/logout.svg" />
                Sign out
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>

  <div class="pos-wrapper">
    @if (navItems.length > 0) {
      <nav class="sidebar" aria-label="Lister sections" [hidden]="hideSideBar">
        <div class="w-100 h-100">
          <div class="menu">
            <ul class="ps-0">
              @for (item of navItems; track item.section) {
                <li [class.active]="activeSection === item.section">
                  @if (item.children.length > 1) {
                    <button
                      type="button"
                      class="first-a"
                      [id]="'nav-' + item.section"
                      aria-controls="section-submenu"
                      [attr.aria-expanded]="isSubmenuOpen && activeSection === item.section"
                      (click)="onSubmenuSectionClick(item)"
                    >
                      <span class="nav-pill">
                        <ng-container
                          [ngTemplateOutlet]="navIcon"
                          [ngTemplateOutletContext]="{ $implicit: item, light: activeSection === item.section }"
                        ></ng-container>
                      </span>
                      <span class="icondesc">{{ item.label }}</span>
                    </button>
                  } @else {
                    <a
                      class="first-a"
                      [id]="'nav-' + item.section"
                      [routerLink]="item.route"
                      [attr.aria-current]="activeSection === item.section ? 'page' : null"
                      (click)="selectSection(item.section, false)"
                    >
                      <span class="nav-pill">
                        <ng-container
                          [ngTemplateOutlet]="navIcon"
                          [ngTemplateOutletContext]="{ $implicit: item, light: activeSection === item.section }"
                        ></ng-container>
                      </span>
                      <span class="icondesc">{{ item.label }}</span>
                    </a>
                  }
                </li>
              }
            </ul>
          </div>
        </div>
      </nav>
    }

    <div
      id="section-submenu"
      class="setup-menu"
      [class.expand-view-open]="isSubmenuOpen"
      [class.expand-view-close]="!isSubmenuOpen"
      [attr.inert]="isSubmenuOpen ? null : ''"
    >
      <div class="setupheader d-flex align-items-center">
        <p>{{ activeItem?.label }}</p>
      </div>
      <ul class="ps-0 mt-1">
        @for (link of activeSubmenu; track link.route) {
          <li>
            <a routerLinkActive="active" ariaCurrentWhenActive="page" [routerLink]="link.route">
              <span class="text">{{ link.label }}</span>
            </a>
          </li>
        }
      </ul>
    </div>

    <div id="content">
      <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -- a click anywhere in the page closes the submenu; it is not a control, so it takes no keys from the page -->
      <main #mainContent id="main" tabindex="-1" class="main-content" (click)="collapseMenu()">
        @switch (pageState) {
          @case ('error') {
            <section class="shell-state" role="alert" aria-labelledby="shell-error-title">
              <h1 id="shell-error-title" class="shell-state-title">We could not load your account</h1>
              <p class="shell-state-text">Check your connection and try again.</p>
              <button type="button" class="btn shell-btn-primary" (click)="retryShell()" id="btn-retryShell">
                Retry
              </button>
            </section>
          }
          @case ('noAccess') {
            <section class="shell-state" aria-labelledby="shell-no-access-title">
              <h1 id="shell-no-access-title" class="shell-state-title">You don't have access to any Lister pages</h1>
              <p class="shell-state-text">Ask your administrator for access, or open another Brijjworks app.</p>
              <div class="shell-state-apps">
                <ng-container [ngTemplateOutlet]="appSwitcher"></ng-container>
              </div>
              <button type="button" class="btn btn-outline-secondary" (click)="signOut()" id="btn-noAccessSignOut">
                Sign out
              </button>
            </section>
          }
          @default {
            <router-outlet />
          }
        }
      </main>
    </div>

    <!-- Bootstrap modal for choosing the warehouse and location; switchModule() opens it. -->
    <div
      #warehouseModal
      class="modal fade"
      id="select-outlet-modal"
      aria-hidden="true"
      aria-labelledby="warehouse-modal-title"
      tabindex="-1"
      (hide.bs.modal)="onWarehouseModalHide($event)"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="custom-modal-header py-0 modal-header">
            <h5 class="mb-0 border-0" id="warehouse-modal-title">
              {{ isFirstRun ? 'Choose your warehouse' : 'Switch warehouse' }}
            </h5>
            @if (canCloseWarehouseModal()) {
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                [disabled]="isSavingWarehouse"
                id="btn-CloseWarehouseModal"
              ></button>
            }
          </div>
          <div class="custom-modal-body modal-body">
            @if (isLoadingWarehouses) {
              <div class="d-flex align-items-center gap-2 py-4" role="status">
                <span class="spinner-border spinner-border-sm warehouse-spinner" aria-hidden="true"></span>
                <span>Loading warehouses...</span>
              </div>
            } @else if (warehousesLoadFailed) {
              <div class="alert alert-danger d-flex justify-content-between align-items-center my-3" role="alert">
                <span>Could not load warehouses.</span>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger"
                  (click)="retryWarehouseLoad()"
                  id="btn-RetryWarehouseLoad"
                >
                  Retry
                </button>
              </div>
            } @else if (warehouseList.length === 0) {
              <p class="warehouse-empty py-4 mb-0">No warehouses are assigned to you. Ask your administrator.</p>
            } @else {
              @if (locationsLoadFailed) {
                <div
                  class="alert alert-danger d-flex justify-content-between align-items-center mt-3 mb-0"
                  role="alert"
                >
                  <span>Could not load warehouse locations.</span>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-danger"
                    (click)="retryWarehouseLoad()"
                    id="btn-RetryLocationLoad"
                  >
                    Retry
                  </button>
                </div>
              }
              <div class="modal-body-wraapper">
                <div class="enter mb-3">
                  <label for="select-warehouse" class="form-label">
                    Warehouse
                    <span class="required-star">*</span>
                  </label>
                  <select
                    id="select-warehouse"
                    class="form-select border"
                    [(ngModel)]="selectedWarehouseId"
                    (change)="getWarehouseLocations()"
                  >
                    <option [ngValue]="0" hidden>Select warehouse</option>
                    @for (item of warehouseList; track item.id) {
                      <option [ngValue]="item.id">{{ item.name }}</option>
                    }
                  </select>
                </div>
                <div class="enter pt-2">
                  <label for="select-warehouse-location" class="form-label">
                    Location
                    <span class="required-star">*</span>
                  </label>
                  <select
                    id="select-warehouse-location"
                    class="form-select border"
                    [(ngModel)]="selectedWarehouseLocationId"
                    [disabled]="isLoadingLocations || warehouseLocationsList.length === 0"
                  >
                    <option [ngValue]="null" hidden>
                      {{ isLoadingLocations ? 'Loading locations...' : 'Select location' }}
                    </option>
                    @for (item of warehouseLocationsList; track item.id) {
                      <option [ngValue]="item.id">{{ item.name }}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="radio-btn">
                <input class="form-check-input" type="checkbox" id="preference" [(ngModel)]="saveAsDefault" />
                <label for="preference">Save my preference</label>
              </div>
            }
          </div>
          <div class="custom-modal-footer modal-footer pt-0">
            @if (showModalSignOut) {
              <button
                type="button"
                class="btn btn-link warehouse-sign-out me-auto"
                (click)="signOut()"
                id="btn-WarehouseSignOut"
              >
                Sign out
              </button>
            }
            @if (!isLoadingWarehouses && !warehousesLoadFailed && warehouseList.length > 0) {
              @if (continueBlockedReason) {
                <span id="continue-reason" class="continue-reason">{{ continueBlockedReason }}</span>
              }
              <button
                type="button"
                class="btn modal-btn text-nowrap"
                [disabled]="!!continueBlockedReason || isSavingWarehouse"
                [attr.aria-describedby]="continueBlockedReason ? 'continue-reason' : null"
                (click)="SaveWarehouse()"
                id="btn-Continue"
              >
                {{ isSavingWarehouse ? 'Switching...' : 'Continue' }}
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- The backdrop is a click target only; Escape and the close button close the drawer from the keyboard. -->
<div class="mobile-backdrop" [class.is-open]="showMobileMenu" (click)="closeMobileMenu()" aria-hidden="true"></div>

<nav
  id="mobile-drawer"
  class="mobile-drawer"
  [class.is-open]="showMobileMenu"
  [attr.inert]="showMobileMenu ? null : ''"
  aria-label="Main menu"
>
  <div class="drawer-header d-flex justify-content-between align-items-center p-3">
    <img src="assets/brand/brijjworks-logo-primary.svg" alt="Brijjworks" class="drawer-logo" />
    <button
      #drawerCloseButton
      type="button"
      class="close-btn"
      (click)="closeMobileMenu()"
      id="btn-closeMobileDrawer"
      aria-label="Close menu"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#666"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
        focusable="false"
      >
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>

  <div class="drawer-profile-container">
    <div class="drawer-profile-card">
      <div class="drawer-avatar">
        <img [src]="userDetails?.profileImgUrl || user.profileFileUrl || 'assets/images/default-profile.png'" alt="" />
      </div>
      <div class="drawer-user-info">
        <div class="drawer-user-name">
          {{ userDetails?.displayName || userDetails?.fullName }}
        </div>
        @if (status === 'ready') {
          <button
            type="button"
            class="drawer-user-warehouse"
            (click)="switchWarehouseMobile()"
            id="btn-mobileWarehouseSwitch"
            [attr.aria-label]="'Switch warehouse, current: ' + warehouseLabel"
          >
            Warehouse:
            <span class="green-text">{{ warehouseLabel }}</span>
          </button>
        }
      </div>
    </div>
  </div>

  <div class="drawer-nav">
    @for (item of navItems; track item.section) {
      @if (item.children.length > 1) {
        <div class="drawer-nav-item drawer-nav-group" [class.active]="activeSection === item.section">
          <ng-container
            [ngTemplateOutlet]="navIcon"
            [ngTemplateOutletContext]="{ $implicit: item, light: false }"
          ></ng-container>
          <span>{{ item.label }}</span>
        </div>
        <div class="drawer-submenu">
          @for (link of item.children; track link.route) {
            <a
              class="drawer-submenu-item"
              [routerLink]="link.route"
              routerLinkActive="active"
              ariaCurrentWhenActive="page"
              (click)="closeMobileMenu()"
            >
              {{ link.label }}
            </a>
          }
        </div>
      } @else {
        <a
          class="drawer-nav-item"
          [class.active]="activeSection === item.section"
          [routerLink]="item.route"
          [attr.aria-current]="activeSection === item.section ? 'page' : null"
          (click)="closeMobileMenu()"
        >
          <ng-container
            [ngTemplateOutlet]="navIcon"
            [ngTemplateOutletContext]="{ $implicit: item, light: false }"
          ></ng-container>
          <span>{{ item.label }}</span>
        </a>
      }
    }

    <div class="drawer-divider my-2"></div>

    <div class="drawer-apps">
      <h2 class="drawer-section-title">Apps</h2>
      <ng-container [ngTemplateOutlet]="appSwitcher"></ng-container>
    </div>

    <div class="drawer-divider my-2"></div>

    <button type="button" class="drawer-nav-item logout-item" (click)="signOut()" id="btn-mobileSignOut">
      <img src="assets/icons/nav/logout.svg" alt="" class="logout-icon" />
      <span class="logout-text">Sign out</span>
    </button>
  </div>
</nav>

<ng-template #navIcon let-item let-light="light">
  @if (item.icon) {
    <img [src]="'assets/icons/nav/' + item.icon + (light ? '-white' : '') + '.svg'" alt="" />
  } @else {
    <svg
      class="nav-svg"
      [class.nav-svg-light]="light"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  }
</ng-template>

<ng-template #appSwitcher>
  <p class="app-switcher-current">
    You are in
    <strong>Lister</strong>
  </p>
  @if (otherApps.length > 0) {
    <div class="icon-grid">
      @for (app of otherApps; track app.id) {
        <a class="icon-item" [href]="app.url">
          <img [src]="app.icon" alt="" />
          <span>{{ app.name }}</span>
        </a>
      }
    </div>
  } @else {
    <p class="app-switcher-empty mb-0">You have no other Brijjworks apps.</p>
  }
</ng-template>
